// mixin for some scenario study area handling
import { mapGetters } from "vuex";
import { types } from "@/store/types";

export const StudyArea = {
  computed: {
    /* jshint ignore:start */
    ...mapGetters([types.getters.SELECTED_REGIONS])
    /* jshint ignore:end */
  },

  methods: {
    validate() {
      // some required field validations
      if (!this.SELECTED_REGIONS.length) {
        return new Promise(resolve => {
          this.errorAlert("Please select a study area to proceed");
          resolve(false);
        });
      }

      return new Promise(resolve => {
        resolve(true);
      }).then(res => {
        this.$emit("on-validated", res, "tab_region");
        return res;
      });
    }
  }
};
